import React from 'react';
import { v4 as uuid } from 'uuid';
import { Helmet } from 'react-helmet';

import { makeStyles } from '@material-ui/core/styles';

import Header from './Header';
import Features from '../CB11Patch/Features';
import TechSpecs from '../CB11Patch/TechSpecs';
import I18n from '../I18n';

const featuresInfo = [
  {
    flexDirection: 'row-reverse',
    text: [`${I18n('CB12.highlight_1')}`],
    imgSrc: '/CB12/CB12Back.png',
    imgAlt: 'CB12 handheld'
  },
  {
    flexDirection: 'row',
    text: [
	    `${I18n('CB12.highlight_2')}`,
	    `${I18n('CB12.highlight_3')}`
    ],
    imgSrc: '/CB12/CB12held.svg',
    imgAlt: 'CB12 handheld held in hands'
  },
  {
    flexDirection: 'row-reverse',
    text: [`${I18n('CB12.highlight_4')}`],
    imgSrc: '/devices/pixel_ECG_port.png',
    imgAlt: 'pixel phone showing ECG'
  }
];

const specInfo = [
  {
    title: `${I18n('CB12.dimension')}`,
    detail: `${I18n('CB12.dimension_value')}`
  },
  {
    title: `${I18n('CB12.range')}`,
    detail: `${I18n('CB12.rang_value')}`
  },
  {
    title: `${I18n('CB12.input')}`,
    detail: `${I18n('CB12.input_value')}`
  },
  {
    title: `${I18n('CB12.frequency')}`,
    detail: `${I18n('CB12.frequency_value')}`
  },
  {
    title: `${I18n('CB12.rate')}`,
    detail: `${I18n('CB12.rate_value')}`
  },
  {
    title: `${I18n('CB12.battery_type')}`,
    detail: `${I18n('CB12.battery_type_value')}`
  },
  {
    title: `${I18n('CB12.connect')}`,
    detail: `${I18n('CB12.connect_value')}`
  }
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  }
}));

const CB12Handheld = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Helmet>
        <title>{I18n('CB12.title')} {I18n('CB12.description')} </title>
        <meta
          name="description"
          content="Handheld ECG sensor. Medical grade short-term cardiac monitoring. Takes a 30-180 second ECG recording."
        />
      </Helmet>
      <Header />
      {featuresInfo.map((info) => (
        <Features key={uuid()} {...info} />
      ))}
      <TechSpecs title={I18n('CB12.technical_specs')} specInfo={specInfo} />
    </div>
  );
};

export default CB12Handheld;
